import * as React from 'react'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import '../styles/Modal.scss'
import CustomButton from '../components/styled/CustomButton'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import ConfirmedMessageModal from './ConfirmedMessage'
import { Button } from '@mui/material'
import { ScaleLoader } from 'react-spinners'
import { updateDataById } from '../apis/generalApis'
import Swal from 'sweetalert2'
import { useNavigate } from 'react-router-dom'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  maxHeight: '90vh',
  overflow: 'auto',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: '0px 5px 20px #00000040',
  p: 4,
  outline: 'none',
  borderRadius: '16px',
  textAlign: 'center',
}

const ConfirmationModal = ({
  handleConfirmationModal,
  modalOpen = false,
  description,
}) => {
  const user = JSON.parse(localStorage.getItem('user'))
  const [confimedMessageModal, setConfimedMessageModal] = React.useState(false)
  const [isLoading, setIsLoading] = React.useState(false)
  const navigate = useNavigate()
  const handleConfirmedMessageModal = () => {
    if (modalOpen) {
      handleConfirmationModal(false)
    }
    setConfimedMessageModal(!confimedMessageModal)
  }

  const handlePauseAccount = async () => {
    setIsLoading(true)
    let response = await updateDataById('pause-account', { user_id: user?.id })
    setIsLoading(false)
    if (response?.success === true) {
      Swal.fire({
        title: 'Account Paused',
        text: 'Your account has been paused.',
        icon: 'success',
        timer: 3000,
        confirmButtonColor: '#2597F6',
      }).then(async () => {
        setIsLoading(true)
        let response = await updateDataById('user-logout', {
          user_id: user?.id,
        })
        if (response?.success === true) {
          localStorage.clear()
          navigate('/login')
        }
      })
    }
  }

  return (
    <>
      <ScaleLoader
        color="#36d7b7"
        loading={isLoading}
        style={{
          position: 'fixed',
          left: 0,
          right: 0,
          height: '100%',
          top: 0,
          display: 'flex',
          zIndex: 1500,
          justifyContent: 'center',
          alignItems: 'center',
          backdropFilter: 'blur(10px)',
          background: '#ffffff00 0% 0% no-repeat padding-box',
        }}
      />
      <Modal
        open={modalOpen}
        onClose={() => handleConfirmationModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="confirmation-modal">
          <div className="text-left">
            <p className="fs-16 color-primary">Are you sure?</p>
            <p className="opacity-50 fs-12">
              Phasellus finibus enim nulla, quis ornare odio facilisis eu.
              Suspendisse ornare ante sit amet arcu semper, vel eleifend tortor
              egestas.
            </p>
            <div
              className="mt-4 pointer"
              onClick={() => handleConfirmationModal(false)}
            >
              {/* <CustomButton title={'No'} fullWidth={true} /> */}
              {/* <Button fullWidth id="btn-primary-no-shadow">
                No
              </Button> */}
              <Button
                fullWidth
                sx={{
                  background:
                    'transparent linear-gradient(180deg, #01ced1 0%, #14b1e4 44%, #2992fb 100%)',
                  borderRadius: '10px',
                  color: '#fff',
                }}
                // onClick={handlePauseAccount}
              >
                No
              </Button>
            </div>
            <div className="mt-3" onClick={handleConfirmedMessageModal}>
              <Button
                fullWidth
                sx={{
                  backgroundColor: '#D40000 !important',
                  borderRadius: '10px',
                  color: '#fff',
                }}
                onClick={handlePauseAccount}
              >
                Yes
              </Button>
              {/* <CustomButton title={'Yes'} background={'red'} fullWidth={true} /> */}
            </div>
          </div>
        </Box>
      </Modal>
      {/* <ConfirmedMessageModal
        handleConfirmedMessageModal={handleConfirmedMessageModal}
        modalOpen={confimedMessageModal}
      /> */}
    </>
  )
}

export default ConfirmationModal
